import { formatAmpersand } from '../../utils/formatAmpersand';
import paginateSearch from '../../utils/paginateSearch';
import {
  clearPermalinkSlug,
  setPermalinkRouteRedirect,
} from '../../utils/sessionStorageHelper';
import { SIGNOUT_USER_SUCCESS } from '../User/UserTypes';
import * as TYPES from './VenuesTypes';

const initialState = {
  venue: null,
  venueId: null,
  inLocalMarket: null,
  list: [],
  pages: [],
  totalCount: 0,
  totalPages: 0,
  events: [],
  getEventsStatus: {
    error: null,
    loading: null,
  },
  findVenuesStatus: {
    error: null,
    loading: null,
  },
  searchVenuesStatus: {
    error: null,
    success: null,
  },
  venuesByMarketStatus: {
    error: null,
    success: null,
  },
  venuesByCuratedPick: [],
};

export default function venueReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TYPES.FIND_VENUES_REQUEST:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          error: null,
          loading: true,
        },
      };
    case TYPES.FIND_VENUES_FAIL:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          error: payload,
          loading: false,
        },
      };
    case TYPES.GET_VENUE_SUCCESS:
      let formattedPayload = {
        ...payload,
        name: payload.name ? formatAmpersand(payload.name) : payload.name,
      };
      return {
        ...state,
        venue: formattedPayload,
      };
    case TYPES.GET_VENUE_BY_SLUG_SUCCESS:
      clearPermalinkSlug();
      setPermalinkRouteRedirect(payload);
      return {
        ...state,
      };
    case TYPES.SET_VENUES:
      const list = (payload.list ?? []).map((item) => ({
        ...item,
        name: formatAmpersand(item.name),
      }));
      const venuesByCuratedPick = (payload.venuesByCuratedPick ?? []).map(
        (venueGroup) => ({
          ...venueGroup,
          venues: (venueGroup.venues ?? []).map((venue) => ({
            ...venue,
            name: formatAmpersand(venue.name),
          })),
        })
      );
      const { totalPages, pages } = paginateSearch(list);
      return {
        ...state,
        list,
        pages,
        totalCount: list.length,
        totalPages,
        venuesByCuratedPick,
      };
    case TYPES.RESET_VENUE_LIST:
      return {
        ...initialState,
        venue: state.venue,
      };
    case TYPES.SEARCH_VENUES_REQUEST:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: true,
        },
        searchVenuesStatus: {
          ...state.searchVenuesStatus,
          success: null,
        },
        venuesByMarketStatus: {
          error: null,
          success: null,
        },
      };
    case TYPES.SEARCH_VENUES_SUCCESS:
      return {
        ...state,
        inLocalMarket: payload.inLocalMarket,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: false,
        },
        searchVenuesStatus: {
          error: null,
          success: true,
        },
      };
    case TYPES.SEARCH_VENUES_FAIL:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: false,
        },
        searchVenuesStatus: {
          error: payload,
          success: false,
        },
      };
    case TYPES.VENUES_BY_MARKET_REQUEST:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: true,
        },
        searchVenuesStatus: {
          error: null,
          success: null,
        },
        venuesByMarketStatus: {
          ...state.venuesByMarketStatus,
          success: null,
        },
      };
    case TYPES.VENUES_BY_MARKET_SUCCESS:
      return {
        ...state,
        inLocalMarket: true,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: false,
        },
        venuesByMarketStatus: {
          error: null,
          success: true,
        },
      };
    case TYPES.VENUES_BY_MARKET_FAIL:
      return {
        ...state,
        findVenuesStatus: {
          ...state.findVenuesStatus,
          loading: false,
        },
        venuesByMarketStatus: {
          error: payload,
          success: false,
        },
      };
    case TYPES.GET_EVENTS_REQUEST:
      return {
        ...state,
        getEventsStatus: {
          error: null,
          loading: true,
        },
      };
    case TYPES.GET_EVENTS_SUCCESS:
      return {
        ...state,
        events: payload,
        getEventsStatus: {
          error: null,
          loading: false,
        },
      };
    case SIGNOUT_USER_SUCCESS:
      return initialState;
    default:
      return state;
  }
}
